import axios from "axios";

// const BASE_URL = "http://localhost:5000/api/";
// const BASE_URL = "https://shiva-e-commerce.herokuapp.com/api/";
const BASE_URL = "https://shivashop.onrender.com/api/";

const user = JSON.parse(localStorage.getItem("persist:root"))?.user;
const currentUser = user && JSON.parse(user).currentUser;
const TOKEN = currentUser?.accessToken;

export const publicRequest = axios.create({
  baseURL: BASE_URL,
});

export const userRequest = axios.create({
  baseURL: BASE_URL,
  header: { token: `Bearer ${TOKEN}` },
});
